import React from "react";

export default class ContactForm extends React.Component {

    render() {
        return(
            <div className="contact-form-container">
                <h1>Talk to us anytime.</h1>
                <p>Our experts and developers would love to contribute their<br/>
                    expertise and insights to your potencial projects.</p>
                <form name="contact" method="post" className="contact-form">
                    <input type="hidden" name="form-name" value="contact" />
                    <div>
                        <div>
                            <label>Name *</label>
                            <input name="name" type='text' required />
                        </div>
                        <div>
                            <label>Email *</label>
                            <input name="email" type='text' required />
                        </div>
                    </div>
                    <div>
                        <label>Message *</label>
                        <textarea name="message" id="contact-textarea" maxLength='2000' required />
                    </div>
                    <button type="submit">Submit</button>
                </form>
            </div>
        )
    }
}